/**
 * Parses error messages from error object
 * and concatenates them into one message.
 */
export const combineAllErrors = (errors) => {
  return Object.values(errors).join('\n');
};

export default combineAllErrors;
